export default __webpack_public_path__ + "static/media/gift.8599959d.svg";